import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const organisationDefinition: ResourceDefinition = {
  title: 'Organisations',
  nameSingular: 'Organisation',
  namePlural: 'Organisations',
  className: 'Organisation',
  mainIdentifier: 'name',
  slug: 'taxonomies/organisations',
  path: 'organisations',
  icon: 'icon-hexagon',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (organisation) => ({
        type: ActionType.Link,
        link: {
          path: `${organisationDefinition.path}/${organisation.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (organisation) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: organisation,
          definition: organisationDefinition
        }
      })
    }
  ]
}
